export const TIMEZONE_LIST = Intl.supportedValuesOf('timeZone');

export const TIMEZONE_OPTIONS = TIMEZONE_LIST.map(timezone => ({
  label: timezone,
  value: timezone,
}));
